import React, { useState } from 'react';

function Button({ children, onClick, className = '' }) {
  const [hovered, setHovered] = useState(false);

  // Handle shine-out animation on mouse leave
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <button
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`
        flex items-center justify-center
        px-4 py-1.5
        text-xl font-semibold
        bg-gradient-to-br from-gray-900 via-gray-950 to-gray-800
        border-2 border-yellow-300 border-opacity-40
        rounded-full
        shadow-lg
        transition-all duration-300
        relative
        overflow-hidden
        before:absolute before:inset-0 before:rounded-2xl before:pointer-events-none before:bg-gradient-to-r before:from-[#ffe066] before:to-[#bfa14a] before:z-10
        after:absolute after:inset-0 after:rounded-2xl after:pointer-events-none after:bg-[radial-gradient(ellipse_at_top,#fff7c2_0%,transparent_70%)] after:opacity-10 after:z-0
        hover:shadow-yellow-100/20 hover:shadow-2xl
        hover:scale-105
        focus:outline-none
        ${className}
      `}
      style={{
        boxShadow: '0 2px 10px 0 rgba(191, 161, 74, 0.08) inset, 0 1px 8px 0 rgba(0,0,0,0.25) inset',
      }}
    >
      <span
        className="relative z-20 w-full text-center"
        style={{
          color: '#f5e7b2',
          textShadow: '0 1px 0 #fff, 0 3px 0 #bfa14a, 0 2px 3px #000',
        }}
      >
        <div className={`shine-effect ${hovered && 'shine-move-in'}`}>{children}</div>
      </span>
      <style>{`
        .shine-effect {
          position: relative;
          display: inline-block;
        }
        .shine-effect::after {
          content: '';
          position: absolute;
          bottom: -20px; right: 100px;
          width: 50%; height: 60px;
          background: linear-gradient(100deg, rgba(255,255,255,0.0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0.0) 100%);
          transform: skewX(-20deg);
          transition: none;
          pointer-events: none;
        }
        .shine-move-in::after {
          animation: shine-move-in 0.4s forwards;
        }
        @keyframes shine-move-in {
          0% { right: 100px; }
          70% { right: -120px; }
          71% { right: 160px; }
          100% { right: 100px; }
        }
      `}</style>
    </button >
  );
}

export default Button; 
